import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getJobActivityLog } from '../api/jobDetailApi';

export function useJobActivityLog(jobId: number) {
  return useQuery({
    // Keyed on `jobs.activityLog` — the key every mutation that affects the log
    // already invalidates. It previously sat under `jobs.detail`, so those
    // invalidations matched nothing and the tab served stale data (SC-6369).
    queryKey: queryKeys.jobs.activityLog(String(jobId)),
    queryFn: () => getJobActivityLog(jobId),
    enabled: jobId > 0,
  });
}
